import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        window.addEventListener('heroProgress', (e) => {
            this.el.style.setProperty('--hero-progress', e.detail.progress);
        });
    }

    init() {
    }
}
